import React from "react";

import { FormControl, FormLabel, Grid, TextField } from "@mui/material";

interface IssueLoaderFormProps {
  issueTitles: string[];
  setIssueTitles: (newIssueTitle: string[]) => void;
  issuesCount: number;
  setIssuesCount: (newIssuesCount: number) => void;
}

const IssueLoaderForm = ({
  issueTitles,
  setIssueTitles,
  issuesCount,
  setIssuesCount,
}: IssueLoaderFormProps) => {
  return (
    <FormControl fullWidth>
      <Grid
        container
        direction="row"
        alignItems="center"
        paddingTop={1}
        spacing={4}
      >
        <Grid item xs={6}>
          <FormLabel required>Issues title</FormLabel>
          <br></br>
          <FormLabel>Ex: Issues Title 1, Issues Title 2 ...</FormLabel>
        </Grid>
        <Grid item xs={6}>
          <TextField
            multiline
            name="issue-titles-input"
            placeholder="Input Issues titles"
            inputProps={{
              "data-testid": "issue-titles-input",
            }}
            fullWidth
            margin="normal"
            variant="outlined"
            onChange={(e) => {
              if (e.target.value.trim() === "") {
                setIssueTitles([]);
                return;
              }
              setIssueTitles(e.target.value.split(","));
            }}
            value={issueTitles}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" alignItems="center" paddingTop={1}>
        <Grid item xs={6}>
          <FormLabel required>Number of issues to create</FormLabel>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <TextField
            id="issues-count-input"
            value={issuesCount.toString()}
            fullWidth
            type="number"
            onChange={(e) => {
              let count = parseInt(e.target.value);
              if (count > 1000) {
                count = 1000;
              }
              if (Number.isNaN(count) || count < 0) {
                count = 0;
              }
              setIssuesCount(Math.abs(count));
            }}
            margin="normal"
            variant="outlined"
            InputProps={{
              inputProps: {
                min: 0,
                max: 100,
                "data-testid": "issues-count-input",
              },
            }}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default IssueLoaderForm;
